<template>
  <div class="artist-card fade-in-fast">
    <router-link
      class="artist-card__link"
      :to="{ name: 'Artist', params: { id: artistData.permlink } }"
    >
      <div class="artist-card__image">
        <div
          class="artist-card__image__tagline"
          :class="
            artistType == 'Resident'
              ? 'artist-card__image__tagline--resident'
              : 'artist-card__image__tagline--guest'
          "
        >
          <span>{{ artistType }}</span>
        </div>
        <picture class="artist-card__image__thumb-container">
          <img
            class="artist-card__image__thumb-container__thumb"
            :src="$router.options.imagePath + artistData.mediaUrl"
          />
        </picture>
      </div>
      <div class="artist-card__data">
        <div class="artist-card__data__wrapper">
          <div class="artist-card__data__header">
            <span>{{ artistData.locationModel.locationname }}</span>
          </div>
          <div class="artist-card__data__heading">
            <div class="artist-card__data__heading__title">
              {{ artistData.name }}
            </div>
            <div class="artist-card__data__heading__frequency">
              <span>{{ artistData.frequency }}</span>
            </div>
          </div>
          <div v-if="$slots['artist-description']" class="artist-card__data__description">
            <slot name="artist-description" />
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'ArtistCard',
  props: {
    artistData: { type: Object, required: true },
    artistType: { type: String, required: false, default: '' }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_artist-card.scss';
</style>
